export default __webpack_public_path__ + "static/media/ppv1.76acc553.png";